import { useCallback } from 'react';

import { TargetModel, TargetStatus } from '../../../../modules/Apps';
import { useUpdateTarget } from '../../../../modules/Apps/Targets';
import { ConfirmationDialog } from '../../../common/ConfirmationDialog';
import { useToastNotification } from '../../../common/Toaster';

interface DisableTargetDialogProps {
  isOpen: boolean;
  handleClose: VoidFunction;
  target: TargetModel;
}

export function DisableTargetDialog({ isOpen, handleClose, target }: DisableTargetDialogProps) {
  const { mutateAsync, isPending } = useUpdateTarget();
  const toaster = useToastNotification();

  const disableTarget = useCallback(async () => {
    try {
      await mutateAsync({ ...target, status: TargetStatus.Disabled });
      toaster.showSuccess('Target was successfully disabled!');
      handleClose();
    } catch (error) {
      toaster.showError('There was an error disabling the target. Please, try again later.');
    }
  }, [mutateAsync, target, toaster, handleClose]);

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      confirmButtonLabel="Disable"
      heading="Disable Target"
      text={`Are you sure you want to disable ${target.name} Target?`}
      handleConfirm={disableTarget}
      handleDismiss={handleClose}
      isConfirmDisabled={isPending}
    ></ConfirmationDialog>
  );
}
